/** An Element Hide Event */
export default class Hide extends CustomEvent {
    /** An element Hide event
        @param {EL} caller Calling node
    */
    constructor(caller) {
        super('hide', {
            bubbles: false,
            detail: {
                caller
            }
        });
    }
}
